import { BannerTile, ListerTile, PrimaryButton, VisualTile } from "@/components"
import { ListerDocumentDataContentBannersItem } from "@/lib/prismicio/types.generated"
import { ContentLoader, Link, useI18n, useLastLister } from "@jog/react-components"
import { gtmProductClickOnLister } from "@jog/shared"
import { NavigationResponse, TweakwiseItem } from "@jog/types"

const Skeleton = () => (
    <section
        role="status"
        aria-live="polite"
        aria-label="Loading products"
        className="grid grid-cols-2 gap-3.5 px-2.5 lg:grid-cols-4 lg:px-0">
        {Array(20)
            .fill(0)
            .map((_, index) => (
                <ContentLoader key={index} height="350px" />
            ))}
    </section>
)

const TwTile = ({
    items,
    onListerTile,
    getGroup,
}: {
    items: TweakwiseItem[]
    onListerTile?: (item: TweakwiseItem) => void
    getGroup: (item: TweakwiseItem) => TweakwiseItem[]
}) => {
    return (
        <>
            {items.map((item) => {
                if (item.origin?.name === "visual" && item.origin?.type === "content-merchandising") {
                    return <VisualTile item={item} key={item.itemno} />
                }
                return <ListerTile key={item.itemno} data={item} group={getGroup(item)} onClick={onListerTile} />
            })}
        </>
    )
}

export const Products = ({
    loaded,
    data,
    banners,
    getGroup,
    category,
}: {
    loaded: boolean
    data: NavigationResponse
    banners?: ListerDocumentDataContentBannersItem[]
    getGroup: (item: TweakwiseItem) => TweakwiseItem[]
    category?: string
}) => {
    const { $t } = useI18n()
    const { recordLister } = useLastLister()
    const onListerTile = (item: TweakwiseItem) => {
        gtmProductClickOnLister(item, category)
        recordLister(data.properties.pageurl, item.itemno)
    }
    if (!loaded || !data) return <Skeleton />
    if (data.items.length === 0)
        return (
            <div className="text-base font-bold">
                <div className="mb-4">{$t("No items found")}</div>
                <Link href="/">
                    <PrimaryButton>{$t("Continue shopping")}</PrimaryButton>
                </Link>
            </div>
        )

    return (
        <section
            role="region"
            aria-label="Product list"
            className="grid grid-flow-dense grid-cols-2 gap-3.5 px-2.5 pt-3.75 md:grid-cols-4 lg:gap-y-7.5 lg:px-0 lg:pt-0">
            <TwTile items={data.items.slice(0, 16)} onListerTile={onListerTile} getGroup={getGroup} />
            <BannerTile banner={banners?.[0]} />
            <TwTile items={data.items.slice(16, 32)} onListerTile={onListerTile} getGroup={getGroup} />
            <BannerTile banner={banners?.[1]} />
        </section>
    )
}
